// import { Component, OnInit } from '@angular/core';

// @Component({
//   selector: 'app-recruitment-reports',
//   templateUrl: './recruitment-reports.component.html',
//   styleUrls: ['./recruitment-reports.component.css']
// })
// export class RecruitmentReportsComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

import { Component, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver';
import { DepartmentDto } from 'src/app/models/DepartmentDto';
import { LocationDto } from 'src/app/models/LocationDto';
import { ManPowerApprovalDto } from 'src/app/models/manpowerapproval-dto';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
import { NotificationType } from 'src/app/models/notification.message';
import { Profile } from 'src/app/models/profile';
import { DateRangeRequest } from 'src/app/models/requests/DateRangeRequest';
import { ManpowerJDDto } from 'src/app/models/requests/ManpowerJDDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { DepartmentsService } from 'src/app/services/departments.service';
import { LocationsService } from 'src/app/services/locations.service';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { ManpowerapprovalService } from 'src/app/services/manpowerapproval.service';
import { ManpowerrecruitmentService } from 'src/app/services/manpowerrecruitment.service';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';
import { VendorsService } from 'src/app/services/vendors.service';

@Component({
    selector: 'app-recruitment-reports',
    templateUrl: './recruitment-reports.component.html',
    styleUrls: ['./recruitment-reports.component.css']
  })export class RecruitmentReportsComponent implements OnInit {
  date:Date[] = [];
  Requests: ManPowerDto[] = [];
  canPrint: boolean = false;
  ViewlevelOfCompliance = false;
  pdf:string="";
  advertDuration: string = '';
  shortListingDuration: string = '';
  interviewDuration: string = '';
  ViewManpowerRecruitment = false;
  OfferProcessDuration: string = '';
  receivedfile: string = "";
  ManPowerJD: ManpowerJDDto[] | undefined;
  ApproveRequest: ManPowerDto | any
  ManPowerRequestApprovals: ManPowerApprovalDto[] | undefined;
  ViewManpowerRequestVisible = false;
  ViewRequestVisible = false;
  currentUser: any;
  Departments: DepartmentDto[] = [];
  
  advertVisible: boolean = false;
  shortListingVisible: boolean = false;
  interviewVisible: boolean = false;
  OfferProcessVisible: boolean = false;
  advertEndVisible: boolean = false;
  shortListingEndVisible: boolean = false;
  interviewEndVisible: boolean = false;
  OfferProcessEndVisible: boolean = false;
  acceptOfferVisible: boolean = false;
  Locations: LocationDto[] | undefined;
  RequestApprovals: ManPowerApprovalDto[] | undefined;
  UpdateRequest: any;
  modeOfRecruitment:string ='';
  selectedDepartmentId: number = 0;
  selectedLocationId:string ='';
  selectedFunctionId:string ='';
  selectedDestinationFunctionId:string ='';
  typeOfVacancy:string ='';
  selectedUserEmail:string ='';
  selectedStatus:string ='';
  Statuses:any[]=[];
  Users :Profile[]=[];

  
 typeofvacancy = [
  { vacancy: "Pending"},
  {  vacancy: "Advert_Ongoing"},
  {  vacancy: "Advert_Ended"},
  { vacancy: "Shortlisting_Ongoing"},
  { vacancy: "Shortlisting_Concluded"},
  { vacancy: "Interview_Ongoing"},
  { vacancy: "Interview_Concluded"},
  { vacancy: "OfferManagement_Ongoing"},
  { vacancy: "OfferManagement_Concluded"},
  { vacancy: "OfferAccepted"},
  { vacancy: "OnHold"},
  { vacancy: "Closed"},
 ]

 

ModeOfrecRuitment = [
  { modeofrecruitments: "FTE"},
  {  modeofrecruitments: "FTC"},
  {  modeofrecruitments: "Consultant"},
  { modeofrecruitments: "Internship"},
 
];
  constructor(private manPowerService: ManPowersService, private manpowerrecruitmentService: ManpowerrecruitmentService, private manpowerservice: ManPowersService,private contractService:ContractsService,private locationService: LocationsService, private notification: NotificationService,
    private vendorService: VendorsService, private manpowerApprovalService: ManpowerapprovalService, private departmentService: DepartmentsService,
    private tokenService: TokenService,private userServis: UserService) { }

  ngOnInit(): void {
    
    this.loadRecords();
  }

  async loadRecords(){
    
    let resRequests = await this.manpowerservice.getManPower().toPromise();
    this.Requests = <ManPowerDto[]>resRequests.responseData;
    let resDeparts = await this.departmentService.getDepartments().toPromise();
    this.Departments = <DepartmentDto[]>resDeparts.responseData;

    let resLocations = await this.locationService.getLocations().toPromise();
    this.Locations = <LocationDto[]>resLocations.responseData;

    let Users = await this.userServis.getUsers().toPromise();
    this.Users = <Profile[]>Users.responseData;
      this.getStatusData();


  }
  async onLocationChange(e: any){
    var obj:any = {}
    obj.reportParam = this.selectedLocationId;
 
        let resRequests = await this.manpowerrecruitmentService.GetRecruitmentByLocation(obj).toPromise();
        this.Requests = <ManPowerDto[]>resRequests.responseData;
        
  }

  async onFunctionChange(e: any){
    var obj:any = {}
    obj.reportParam = this.selectedFunctionId;
 
        let resRequests = await this.manpowerrecruitmentService.RecruitmentByFunction(obj).toPromise();
        this.Requests = <ManPowerDto[]>resRequests.responseData;
        
  }

  
  async onTypeOfVacancyChange(e: any){
    ;
    var obj:any = {}
    obj.reportParam = this.typeOfVacancy;
 
        let resRequests = await this.manpowerrecruitmentService.GetByVacancyStatus(obj).toPromise();
        this.Requests = <ManPowerDto[]>resRequests.responseData;
        
  }

  getColor(status: string): string {
    switch (status) {
      case "MEDIUM":
        return 'badge badge-warning';
      case "LOW":
        return 'badge badge-success';
      case "HIGH":
        return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }

  
  async getJD(datas: ManPowerDto) {
    // this.ViewManPowerVisible = true;
 ;
     this.ApproveRequest = datas;
     let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
     ;
   
     this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;

      this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
      const b = Uint8Array.from(atob(this.receivedfile), c => c.charCodeAt(0));
      const blob = new Blob([b] , {type: "application/octet-stream"});
      FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);
   } 

  async showDocument(datas: ManPowerDto){
    // this.open();
    ;
    let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
       ;
     
       this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;
     
        this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
        this.pdf = getJDRequest.responseData[0].documentContent
     
       // this.PathReportString = 'data:application/pdf;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.receivedfile) as any).changingThisBreaksApplicationSecurity;
              
       // top!.document.getElementById('ifrm')!.setAttribute("src", this.PathReportString)!;
       const pdfWindow = window.open("")!;    
       pdfWindow.document.write("<html<head><title>Additional Report</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");    
       pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +    
       encodeURI(this.receivedfile) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>") 
   
   
   }
  
  
  close(): void {
    this.ViewManpowerRecruitment = false;
    this.canPrint = false;



  }

  
  async openRecruitment(data: ManPowerDto) {
    ;
    this.ViewManpowerRecruitment = true;
    this.UpdateRequest = data;
    this.currentUser = this.tokenService.getInfo();
    if (data.status === "Approved") { this.canPrint = true }
    let resApprovals = await this.manpowerApprovalService.getRequestApprovals(data.id).toPromise();
    this.ManPowerRequestApprovals = <ManPowerApprovalDto[]>resApprovals.responseData;

    this.UpdateRequest = data;
    this.advertDuration  = this.UpdateRequest.advertDuration + " " + "Day(s)"
    this.shortListingDuration = this.UpdateRequest.shortlistingDuration + " " + "Day(s)"
    this.interviewDuration  = this.UpdateRequest.interviewDuration + " " + "Day(s)"
    this.OfferProcessDuration =  this.UpdateRequest.offerManagementDuration  + " " + "Day(s)"
     if(data.vacancyStatus == 'Pending'){
      this.advertVisible = false
      this.advertEndVisible = false
      this.shortListingVisible = false
      this.shortListingEndVisible = false
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus == 'Advert_Ongoing'){
      this.advertVisible = true
      this.advertEndVisible = false
      this.shortListingVisible = false
      this.shortListingEndVisible = false
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
     
    }
    if(data.vacancyStatus == 'Advert_Ended'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = false
      this.shortListingEndVisible = false
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus == 'Shortlisting_Ongoing'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = false
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus == 'Shortlisting_Concluded'){
      this.advertVisible = true
      this.advertEndVisible = false
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = false
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'Interview_Ongoing'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = false
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'Interview_Concluded'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = false
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'OfferManagement_Ongoing'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = true
      this.OfferProcessEndVisible = false
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'OfferManagement_Concluded'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = true
      this.OfferProcessEndVisible = true
      this.acceptOfferVisible = false
    }
    if(data.vacancyStatus === 'OfferAccepted'){
      this.advertVisible = true
      this.advertEndVisible = true
      this.shortListingVisible = true
      this.shortListingEndVisible = true
      this.interviewVisible = true
      this.interviewEndVisible = true
      this.OfferProcessVisible = true
      this.OfferProcessEndVisible = true
      this.acceptOfferVisible = true
    }
  }

  async onModeOfRecruitmentChange(e: any){
    ;
    var obj:any = {}
    obj.reportParam = this.modeOfRecruitment;
 
        let resRequests = await this.manpowerservice.GetByTypeOfVacancy(obj).toPromise();
        this.Requests = <ManPowerDto[]>resRequests.responseData;
        
  }
  onChange(result: Date[]): void {
    
    console.log('onChange: ', result);
    ;
    this.date=result;
    var r1 = result[0];
    var r2 = this.date[0];

  }

  
  async GetByDate()
  {
    ;
   let  theDaStartDate:Date= this.date[0];
   var strtDt  =this.date[0];
   var endDt   =this.date[1];
   if (strtDt>endDt)
   {
    this.notification.sendMessage({
      message: "Start Date cannot be more than end date",
      type: NotificationType.success
    });
   }

   let VeeM :DateRangeRequest={
   startDate :strtDt,
   endDate:endDt
    
   };
    let resRequests = await this.manpowerservice.getByDateRange(VeeM).toPromise();
    this.Requests = <ManPowerDto[]>resRequests.responseData;
  //  this.Requests = <ContractDto[]>resRequests.responseData;

  }

  async onStatusChange(e: any)
  {
    var obj:any = {}
    obj.reportParam = this.selectedStatus;
    let resRequests = await this.manpowerservice.GetByStatus(obj).toPromise();
    this.Requests = <ManPowerDto[]>resRequests.responseData;

  }
  getStatusColor(status: string): string {
    
    switch (status) {
      case "Pending":
        return 'badge badge-warning';
      case "Advert_Ongoing":
        return 'badge badge-secondary';
      case "Advert_Ended":
        return 'badge badge-secondary';
      case "Shortlisting_Ongoing":
        return 'badge badge-success';
      case "Shortlisting_Concluded":
        return 'badge badge-success';
      case "Interview_Ongoing":
        return 'badge badge-light';
      case "Interview_Concluded":
        return 'badge badge-light';
      case "OfferManagement_Ongoing":
        return 'badge badge-info';
      case "OfferManagement_Concluded":
        return 'badge badge-info';
      case "OfferAccepted":
        return 'badge badge-success';
      case "OnHold":
        return 'badge badge-warning';
      case "Closed":
        return 'badge badge-danger';

      default:
        return 'badge badge-info';
    }
  }


  exportExcel() {
    if (this.Requests.length > 0) {
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.Requests);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "ExportExcel");
      });
    }
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }


  
  getStatusData()
  {
   var statuses =  [{
  name:"New",
  value:"New"   } , {name:"Pending",  value:"Pending"  },  {  name:"Approved",   value:"Approved"  } ,{name:"Rejected",  value:"Rejected"},
  {name:"Active",  value:"Active"}, {name:"Completed",  value:"Completed"},{name:"Expired",  value:"Expired"},{name:"Pending_EA",  value:"Pending_EA"}, 
  {name:"Closed",  value:"Closed"}
  
  ];

  this.Statuses =statuses;
  

  }
}

